import {DepositViewAsync as DepositView} from './DepositView.async';

export default DepositView;
